import { Routes } from '@angular/router';
import {
  AppRoutingLogin,
  AppRoutingSelect,
  AppRoutingPasswordResetOtpSessionExpired,
  AppRoutingPasswordReset,
} from './app-routing.model';

export const routes: Routes = [
  {
    path: '',
    redirectTo: AppRoutingLogin,
    pathMatch: 'full',
  },
  {
    path: AppRoutingLogin,
    loadChildren: () => import('./features/login/login-routes'),
  },
  {
    path: AppRoutingPasswordReset,

    loadChildren: () => import('./features/reset-password/reset-password-routes'),
  },
  {
    path: AppRoutingSelect,
    loadChildren: () => import('./features/select-app/select-app-routes'),
  },
  {
    path: AppRoutingPasswordResetOtpSessionExpired,
    loadChildren: () => import('./features/session-expired/session-expired-routes'),
  },
  {
    path: '**',
    redirectTo: AppRoutingLogin,
  },
];
